import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import Article from 'components/ArticleItem'
import ArticlesPagination from 'components/ArticlesPagination'
import Phaser from 'components/Phaser'
import { RootMeta } from 'components/Meta'
import formatCategory from 'utils/formatCategory'

const styles = (theme) => ({
  root: {
    padding: '15px 0',
  },
  body: {
    width: 950,
    [theme.breakpoints.down('md')]: {
      width: 670,
    },
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
    [theme.breakpoints.down('xs')]: {},
  },
})

const CategoryTemplate = ({ classes, theme, data, pathContext }) => {
  const {
    group,
    index,
    pageCount,
    additionalContext: { category },
  } = pathContext
  const {
    site: { siteMetadata },
  } = data

  return (
    <Grid
      classes={{ container: classes.root }}
      spacing={24}
      justify="center"
      container
    >
      <RootMeta
        url={siteMetadata.siteUrl}
        title={`${category} | ${siteMetadata.siteName}`}
        description={siteMetadata.siteDescription}
        breadCrumb={[
          { url: `${siteMetadata.siteUrl}/${category}`, name: category },
        ]}
      />
      <Grid classes={{ item: classes.body }} item>
        <Phaser
          offset={15}
          label={formatCategory(category)}
          color={theme.palette.text.main}
          upperCase
        />
        {group.map((node) => (
          <Article
            key={node.fields.slug}
            slug={node.fields.slug}
            timeToRead={node.timeToRead}
            title={node.frontmatter.title}
            date={node.frontmatter.date}
            src={node.frontmatter.thumbnail}
            excerpt={node.excerpt}
            tags={node.frontmatter.tags}
            category={node.frontmatter.category}
          />
        ))}
        <ArticlesPagination
          currentPage={index}
          totalItems={group.length * pageCount}
          itemsPerPage={group.length}
          prefix={'/' + category}
        />
      </Grid>
    </Grid>
  )
}

CategoryTemplate.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  pathContext: PropTypes.shape({
    category: PropTypes.string,
  }).isRequired,
}

// prettier-ignore
// eslint-disable-next-line
export const query = graphql`
  query CategoryTemplateQuery {
    site {
      siteMetadata {
        siteName
        siteUrl
        siteDescription
      }
    }
  }
`

export default withStyles(styles, { withTheme: true })(CategoryTemplate)



// WEBPACK FOOTER //
// ./src/templates/categories.js